export enum AdminAddActivityTemplateFormItemName {
  Name = "name",
  DaysDelay = "daysDelay",
  RecommendedChannels = "recommendedChannels",
}
